import React from "react";
import { Buffer } from 'buffer';
import { useEffect, useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import "../assets/styles/SignUp.scss";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import { createSession } from "../services/authenticationService.js";
import * as api from "../services/api";
interface Obj {
    pathname: string;
    search: string;
    hash: string;
}
export interface Location {
    location: Obj;
}

interface Iuser {
    firstName: string;
    lastName: string;
    email: string;
    userName: string;
    signUpToken: string;
    password: string;
    confirmPassword: string;
}



const SignUp: React.FC<Location> = (props: Location) => {
    const [user, setUser] = useState<Iuser>({
        firstName: "",
        lastName: "",
        email: "",
        userName: "",
        signUpToken: "",
        password: "",
        confirmPassword: ""
    });
    const [error, setError] = useState<string>("");
    const [confirmError, setConfirmError] = useState<string>("");
    const [show, setShow] = useState<boolean>(false);
    const [password, setPassword] = useState<string>("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfPassword, setShowConfPassword] = useState(false);
    const history = useHistory();

    useEffect(() => {
        const queryParams = new URLSearchParams(props.location.search);
        let token = queryParams.get("code");
        if (token) {
            token = token.replace(/ /g, "+");
            const queryString = JSON.parse(Buffer.from(queryParams.get("detailCode"), "base64")?.toString()) ?? false;
            setUser({
                firstName: queryString.FirstName, lastName: queryString.LastName, email: queryString.Email, userName: queryString.Email, signUpToken: token, password: '', confirmPassword: ''
            });
            LinkExpiry(queryString.GeneratedAt);
        }
    }, [props.location.search]); // eslint-disable-line react-hooks/exhaustive-deps


    const LinkExpiry = async (queryString) => {
        await api.checkLinkExpiry(queryString).then(() => {
            setShow(true);
        }).catch((err) => {
            toast.error(err);
            history.push("/error");
        });
    };

    const isPasswordValid = (e) => {
        e.preventDefault();
        setPassword(e.target.value);

        const passwordValue = e.target.value;

        const uppercaseRegExp = /(?=.*?[A-Z])/;
        const lowercaseRegExp = /(?=.*?[a-z])/;
        const digitsRegExp = /(?=.*?[\d])/;
        const specialCharRegExp = /(?=.*?[!@#$%?&*\-_^+=()<>/~,.{}[\]|`])/;
        const whitespaceRegExp = /(^\S*$)/;

        const uppercasePassword = uppercaseRegExp.test(passwordValue);
        const lowercasePassword = lowercaseRegExp.test(passwordValue);
        const digitsPassword = digitsRegExp.test(passwordValue);
        const specialCharPassword = specialCharRegExp.test(passwordValue);
        const nonWhitespaceRegExp = whitespaceRegExp.test(passwordValue);
        /* istanbul ignore next */
        if (!nonWhitespaceRegExp) {
            setError("White spaces are not allowed");
        } else if (passwordValue.length < 8 || passwordValue.length > 20) {
            setError("Password must be between 8 to 20 characters");
        } else if (!uppercasePassword) {
            setError("It should contain at least one uppercase");
        } else if (!lowercasePassword) {
            setError("It should contain at least one lowercase");
        } else if (!specialCharPassword) {
            setError("It should contain at least one special character");
        } else if (!digitsPassword) {
            setError("It should contain at least one digit");
        } else {
            setError("");
            const confPassword = user.confirmPassword;
            if (passwordValue !== confPassword && confPassword !== '') {
                setConfirmError("The passwords do not match");
            }
            else {
                setConfirmError("");
            }
        }
    };

    const isConfiPasswordValid = (e) => {
        if (password !== e.target.value) return setConfirmError("The passwords do not match");
        return setConfirmError("");
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        /* istanbul ignore next */
        if (password !== user.confirmPassword) return setConfirmError("The passwords do not match");
        else if (!error && !confirmError) {
            delete user.confirmPassword;
            api.signupApi(user).then(() => {
                api.loginApi(user.email, user.password).then((response) => {
                    if (response.token !== undefined && response.token !== null) {
                        createSession(response.token, response.username, response.role, user.email);
                        redirectToHome();
                    } else {
                        toast.error(response);
                    }
                }).catch((err) => {
                    toast.error(err.toString());
                });
            }).catch((err) => {
                toast.error(err.toString());
            });
        }
    };

    const redirectToHome = () => {
        history.push('/viewer_dashboard');
    };

    return (
        <div className="signupform">
            {show
                && (
                    <Form data-testid="signupform" className="signup-form border shadow" onSubmit={handleSubmit} >
                        <div id="heading" className="title text-center"> Sign Up </div>
                        <div className="form mx-auto">
                            <Row className="mb-2 mx-2">
                                <Form.Group as={Col}>
                                    <Form.Label>
                                        First Name
                                        <em className="text-danger">*</em>
                                    </Form.Label>
                                    <Form.Control
                                        type="text" id="text" data-testid="fname" placeholder="Enter First Name" value={user.firstName}
                                        onChange={(e) => setUser({ ...user, firstName: e.target.value })}
                                        onInvalid={(e) => (e.target as HTMLInputElement).setCustomValidity("Please enter your first name")}
                                        onInput={(e) => (e.target as HTMLInputElement).setCustomValidity("")} required
                                    />
                                </Form.Group>
                                <Form.Group as={Col}>
                                    <Form.Label>
                                        Last Name
                                        <em className="text-danger">*</em>
                                    </Form.Label>
                                    <Form.Control
                                        type="text" id="text1" data-testid="lastname" placeholder="Enter Last Name" value={user.lastName}
                                        onChange={(e) => setUser({ ...user, lastName: e.target.value })}
                                        onInvalid={(e) => (e.target as HTMLInputElement).setCustomValidity("Please enter your last name")}
                                        onInput={(e) => (e.target as HTMLInputElement).setCustomValidity("")} required
                                    />
                                </Form.Group>
                            </Row>
                            <Form.Group className="mb-2 mx-4">
                                <Form.Label id="emailLabel"> Email</Form.Label>
                                <Form.Control type="email" id="email" data-testid="email" placeholder="Enter email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" value={user.email} disabled />
                            </Form.Group>
                        </div>

                        <Form.Group className="mb-2" style={{ marginLeft: "2.5rem" }}>
                            <Form.Label id="passwordLabel">
                                Password
                                <em className="text-danger">*</em>
                            </Form.Label>
                            <div className="row">
                                <div className="col-11">
                                    <div style={{ position: 'relative' }}>
                                        <Form.Control
                                            className={`${error ? "is-invalid form-control " : "form-control"}`} type={showPassword ? 'text' : 'password'} aria-describedby="basic-addon1"
                                            data-testid="password" placeholder="Enter Password" value={user.password}
                                            onChange={(e) => { setUser({ ...user, password: e.target.value }); isPasswordValid(e) }}
                                            onInvalid={(e) => (e.target as HTMLInputElement).setCustomValidity("Please enter your password")}
                                            onInput={(e) => (e.target as HTMLInputElement).setCustomValidity("")} required
                                        />
                                        <span className="toggle-password" onClick={() => setShowPassword(!showPassword)} data-testid="toggle-password">
                                            {showPassword ?
                                                <Icon.Eye className='m-2 pointer' onClick={() => setShowPassword(false)} data-testid="eye-icon" />
                                                :
                                                <Icon.EyeSlash className='m-2 pointer' onClick={() => setShowPassword(true)} data-testid="eye-slash-icon" />
                                            }
                                        </span>
                                    </div>
                                </div>
                                <div
                                    className="col-1 mt-1 tooltip-primary" data-toggle="tooltip" data-placement="right" title="Password should contain: &#013; At least 8 to 20 characters &#013;
                                At least one Uppercase letter &#013; At least one Lowercase letter &#013;
                                At least one Number &#013; At least one Special character &#013;&#013;"
                                >
                                    <Icon.InfoCircle />
                                </div>
                            </div>
                            <span data-testid="errormsg" className="error text-danger mt-1 ms-1">
                                {error}
                            </span>
                        </Form.Group>

                        <Form.Group className="mb-2" style={{ margin: "0 2.5rem" }}>
                            <Form.Label id="confirmLabel">
                                Confirm Password
                                <em className="text-danger">*</em>
                            </Form.Label>
                            <div style={{ position: 'relative' }}>
                                <Form.Control
                                    className={`${confirmError ? "is-invalid form-control" : "form-control"}`} type={showConfPassword ? 'text' : 'password'} data-testid="confpassword" placeholder="Retype Password"
                                    value={user.confirmPassword} onInvalid={(e) => (e.target as HTMLInputElement).setCustomValidity("Please re-type your password")}
                                    onInput={(e) => (e.target as HTMLInputElement).setCustomValidity("")} onChange={(e) => { setUser({ ...user, confirmPassword: e.target.value }); isConfiPasswordValid(e) }} required
                                />
                                <span className="toggle-password" onClick={() => setShowConfPassword(!showConfPassword)} data-testid="toggle-confirm-password">
                                    {showConfPassword ?
                                        <Icon.Eye className='m-2 pointer' onClick={() => setShowConfPassword(false)} data-testid="eye-icon1" />
                                        :
                                        <Icon.EyeSlash className='m-2 pointer' onClick={() => setShowConfPassword(true)} data-testid="eye-slash-icon1" />
                                    }
                                </span>
                            </div>
                            <span data-testid="conferrormsg" className="error text-danger mt-1 ms-1">
                                {confirmError}
                            </span>
                        </Form.Group>
                        <div className="text">
                            <Button data-testid="submit-button" className="btn-primary" type="submit"> Sign Up </Button>
                        </div>
                    </Form>
                )}
        </div>
    );
};

export default SignUp;
